import { defineStore } from 'pinia'
import axios from '../api/axiosInstance'
import { sortThreadsByDate } from '../utils/sortThreads'
import { useI18n } from "vue-i18n";
import { i18n } from '../i18n';

export const useUsersStore = defineStore('users', {
  state: () => ({
    users: [],
    currentUser: {
      id: '',
      first_name: '',
      last_name: '',
      is_superuser: false,
      threads: {},
      language: 'mne'
    },
  }),
  getters: {
    getUsers() {
      return this.users
    },
    getCurrentUserId() {
      return this.currentUser.id
    },
    getCurrentUserFirstName() {
      return this.currentUser.first_name
    },
    getCurrentUserFullName() {
      return this.currentUser.first_name + ' ' + this.currentUser.last_name
    },
    getCurrentUserIsSuperuser() {
      return this.currentUser.is_superuser
    },
    getCurrentUserThreads() {
      return this.currentUser.threads
    },
    getThreadName() {
      return (threadId) => {
        const { t } = useI18n(); // Call inside the function
        return this.currentUser.threads?.find(
          (thread) => thread.thread_id === threadId
        )?.name ?? t("common.newConversation"); // Use translation key
      };
    },
    getLanguage(state) {
      return state.currentUser.language;
    },
  },
  actions: {
    setUsers(users) {
      this.users = users
    },
    setCurrentUser(currentUser) {
      this.currentUser = { ...this.currentUser, ...currentUser }
    },
    async setCurrentUserThreads() {

      try {
        let { data } = await axios.get("/assistant/threads")
        if (data.status_code === 404) {
          try {
            let response = await axios.post("/user/create_uuid")
            localStorage.setItem("uuid", response.data.id)
            response = await axios.get("/assistant/threads")
            data = response.data
          } catch (error) {
            console.log(error)
            return
          }
        }
        const threads = sortThreadsByDate(data)
        this.currentUser = { ...this.currentUser, threads }
      } catch (error) {
        console.log(error)
      }
    },
    addThread(thread) {
      this.currentUser = {
        ...this.currentUser,
        threads: [...this.currentUser.threads, thread],
      }
    },
    deleteThread(periodId, threadId) {
      const index = this.currentUser.threads[periodId].findIndex(
        (thread) => thread.thread_id === threadId,
      )
      const new_threads = [...this.currentUser.threads[periodId]]
      new_threads.splice(index, 1)
      this.currentUser.threads[periodId] = new_threads
    },
    deleteAllThreads() {
      this.currentUser = { ...this.currentUser, threads: [] }
    },

    changeLanguage(lang) {
      this.currentUser.language = lang; // Update store state
      sessionStorage.setItem('language', lang);
      i18n.global.locale.value = lang; // ✅ Correct way to change language
    }
  },
})
